import { useFragment } from 'react-relay';
import { iconLinkFragment } from './IconLink.relay';
import { iconLinkClassName } from './lib/IconLinkStyles';
import type { IconLinkPropsType } from './types';

const IconLink: React.FC<IconLinkPropsType> = (props: IconLinkPropsType) => {
  const iconLink = useFragment(iconLinkFragment, props.iconLink);

  return (
    <div className={iconLinkClassName}>
      <a href={iconLink.url} target="_blank" rel="noreferrer">
        <img className="icon" src={process.env.HOST + iconLink.iconUrl} />

        <span className="link-text">{iconLink.label}</span>
      </a>
    </div>
  );
};

export { IconLink };
